module.exports = __webpack_public_path__ + "img/barcodeScannerInfo.e561df8e.svg";